export class ValidateNewTerminalResponseDto {
  // @ApiProperty({
  //   description: 'Determines if a new terminal can be created',
  //   example: true,
  // })
  isValid: boolean;
}
